export default "__VITE_ASSET__CD7jkMfd__"